import { isDevEnv } from '../../config/app';

export const WEAVE_APP_URL = isDevEnv()
  ? 'https://app.weavedev.net'
  : 'https://app.getweave.com';
